<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <h5>Lista Lezioni</h5>
            <button
              type="button"
              id="add-btn"
              class="btn btn-primary"
              @click="this.$router.push({ name: 'LessonAdd', params: {} })"
            >
              + Nuovo
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div
              class="table-responsive p-3"
              id="table"
              :class="{ tloading: loading }"
            >
              <custom-table
                ref="table$"
                :rows="data"
                @action="runAction"
                :columns="[
                  {
                    title: 'ID',
                    type: 'text',
                    link: '/lessons/:id/view',
                    data: 'id',
                  },
                  {
                    title: 'Title',
                    link: '/lessons/:id/view',
                    type: 'text',
                    data: 'title',
                  },
                  {
                    title: 'descrizione',
                    type: 'text',
                    link: '/lessons/:id/view',
                    data: 'description',
                  },
                  {
                    title: 'Student',
                    type: 'text',
                    link: '/lessons/:id/view',
                    data: 'student.username',
                  },
                  {
                    title: 'Start',
                    type: 'date',
                    link: '/lessons/:id/view',
                    data: 'start_date',
                  },
                  {
                    title: 'End',
                    type: 'date',
                    link: '/lessons/:id/view',
                    data: 'end_date',
                  },
                  {
                    title: 'Start Time',
                    type: 'time',
                    link: '/lessons/:id/view',
                    data: 'start_time',
                  },
                  {
                    title: 'End Time',
                    type: 'time',
                    link: '/lessons/:id/view',
                    data: 'end_time',
                  },
                  {
                    title: 'Field',
                    type: 'text',
                    data: 'field.name',
                  },
                ]"
                :actions="[
                  {
                    title: 'Modifica',
                    tooltip: 'edit',
                    key: 'edit',
                  },
                  {
                    title: 'Cancella',
                    tooltip: 'delete',
                    key: 'delete',
                  },
                ]"
                :pagination="pagination"
                @page-changed="handlePageChange"
                @update-pagination="handlePaginationUpdate"
                @search-changed="handleSearchChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Confirmation Modal -->
<div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmationModalLabel">Conferma Azione</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Confermi operazione?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary"  id="close" data-bs-dismiss="modal">Chiudi</button>
        <button type="button" class="btn btn-primary" id="confirmButton" :class="{ loading: loading }" @click="deleteLesson">Conferma</button>
      </div>
    </div>
  </div>
</div>

</template>
<script>

import { lessonsService } from "@/services/LessonsService";
import CustomTable from "@/components/CustomTable";
import { useToast } from "vue-toastification";
import { Modal } from "bootstrap/dist/js/bootstrap.min";
import {useTableData} from "@/composables/useTableData";

const toast = useToast();

export default {
  name: "Lessons",
  computed: {
  },
  data() {
    return {
      selected_lesson: null,
      lessonsData: [],
      loading: false,
    };
  },
  setup(){
    return useTableData(
      lessonsService.list.bind(lessonsService),
        15
    );
  },
  components: {
    CustomTable
  },
  mounted() {
    this.fetchData();
  },
  created() {
    this.$store.dispatch("updateBreadcrumbs", []);
  },
  methods: {
    async runAction({action, row}){
      if(action.key == 'edit'){
        this.$router.push({ name: 'Lesson', params: { id: row.id } });
      }
      if(action.key == 'delete'){
        const myModal = new Modal(document.getElementById('confirmationModal'));
        myModal.show();
        this.selected_lesson = row.id;
      }
    },
    async deleteLesson(){
      this.loading = true;
      await lessonsService.delete(this.selected_lesson);
      this.loading = false;
      toast(this.$t('Deleted'));
      document.getElementById('close').click();
      this.fetchData();
    }
  }
};
</script>